
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Puneairporttaxi() {



    const cardData =
    {
        keyword: 'Pune Airport Taxi',
        heading: 'Meghana Cab : Pune Airport Taxi',
        headingDescription: 'Meghana Cab offers reliable Pune Airport Taxi services, ensuring timely pickups and drop-offs to and from Pune International Airport. Whether you are catching a flight or arriving in the city, our well-maintained cabs and professional drivers provide a smooth and stress-free airport travel experience. With 24/7 availability, real-time tracking, and fixed transparent fares, we guarantee punctuality and peace of mind. Book your Pune Airport Taxi with Meghana Cab and enjoy a comfortable and convenient airport transfer every time.',


        top: 'Top Places to Visit in Pune with Meghana Cab',

"topPlaces": [
  {
    "title": "Pataleshwar Cave Temple",
    "description": "An 8th-century monolithic rock-cut temple dedicated to Lord Shiva, located in the city center. It features beautifully carved pillars, a sanctum with a Shiva Lingam, and a tranquil atmosphere, offering a peaceful retreat from the urban hustle."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Located in Koregaon Park, this internationally known meditation center offers a serene environment for spiritual growth and relaxation. The resort includes lush gardens, wellness sessions, and dynamic meditation programs, attracting visitors from all over the world."
  },
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas of the Maratha Empire, this iconic fortification was once the seat of power. Although much of it was destroyed in a fire, the remaining gates and foundations provide insight into its architectural grandeur. The evening light and sound show adds to its historical allure."
  },
  {
    "title": "Pune-Okayama Friendship Garden",
    "description": "Inspired by Japanese landscape design, this garden offers calm surroundings, flowing water channels, koi ponds, and manicured pathways. It's an ideal location for walking, photography, or simply spending quiet time with family."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Built in 1892, this historic site played a key role during India’s independence movement. It served as a prison for Mahatma Gandhi and his wife Kasturba Gandhi. The palace is surrounded by landscaped gardens and houses a museum dedicated to Gandhi's life."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Located around 20 kilometers from Pune, this dam is a popular destination for short drives, scenic views, and relaxing by the lakeside. The area is especially pleasant during the monsoon season and is often frequented by picnickers and food vendors."
  },
  {
    "title": "Fergusson College Road",
    "description": "A lively street known for its youthful vibe, lined with cafes, bookstores, fashion boutiques, and street food stalls. It's a favorite spot for students and a great place to experience Pune’s modern culture and social scene."
  },
  {
    "title": "Lal Mahal",
    "description": "This historic red-brick palace was built by Shahaji Bhosale in the 1630s for his son Shivaji Maharaj. Though the original structure no longer exists, the rebuilt palace displays important moments from Shivaji’s childhood through murals and artifacts."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "A unique museum showcasing over 20,000 artifacts including sculptures, musical instruments, weapons, household items, and artwork from different periods of Indian history. It offers deep insights into India’s rich cultural and artistic legacy."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Located about 30 kilometers from the city, Sinhagad Fort is an important historical site known for its role in the Battle of Sinhagad. The moderate trek to the top is rewarded with panoramic views, Maratha-era architecture, and local food stalls serving traditional dishes."
  }
],

"services": [
    {
        "name": "Pune Airport Pickup and Drop",
        "description": "Meghana Cab offers seamless Pune Airport pickup and drop services with timely arrivals, professional chauffeurs, and clean vehicles. Whether you're traveling for business or leisure, we ensure a comfortable start or end to your journey with prompt service to and from any part of the city."
    },
    {
        "name": "Pune Airport Cab Booking",
        "description": "Book your airport cab easily with Meghana Cab. Our online booking system allows you to schedule pickups and drops to Pune Airport in advance. Enjoy a hassle-free ride with real-time tracking and on-time service you can trust."
    },
    {
        "name": "Cab to Pune Airport",
        "description": "Heading to the airport? Choose Meghana Cab’s reliable taxi service to Pune Airport for a smooth, timely, and safe ride. We operate 24/7 with a fleet of sedans, SUVs, and budget cars suited for all travelers."
    },
    {
        "name": "Airport Taxi from Pune City",
        "description": "Meghana Cab provides convenient airport taxi services from any location within Pune city. Whether you're in Hinjewadi, Kothrud, Hadapsar, or Baner, our drivers ensure timely drop-offs with complete comfort."
    },
    {
        "name": "Airport Transfer Services Pune",
        "description": "Our airport transfer service in Pune is ideal for solo travelers, families, and corporate clients. Meghana Cab ensures punctual pickups, flight monitoring, courteous drivers, and spacious vehicles tailored for airport journeys."
    },
    {
        "name": "AC Taxi for Pune Airport",
        "description": "Travel in comfort with Meghana Cab’s AC taxis for Pune Airport transfers. Our air-conditioned vehicles ensure a relaxing ride, regardless of the weather or time of day."
    },
    {
        "name": "Affordable Pune Airport Cab",
        "description": "Looking for a budget-friendly ride to the airport? Meghana Cab offers economical airport taxi options in Pune with transparent pricing and no hidden charges."
    },
    {
        "name": "Pune Airport to City Taxi",
        "description": "Arriving in Pune? Get a comfortable ride from Pune Airport to any location in the city with Meghana Cab. Enjoy professional service, clean vehicles, and fixed fares from airport to doorstep."
    },
    {
        "name": "24/7 Airport Cab Service Pune",
        "description": "Our airport cab service in Pune runs round the clock. Whether it’s an early morning flight or a late-night landing, Meghana Cab is ready to serve you with punctual, safe, and reliable rides."
    },
    {
        "name": "Book Sedan for Pune Airport Drop",
        "description": "Need a stylish and comfortable sedan for your airport drop? Meghana Cab offers premium sedan options for solo or couple travelers who value comfort, class, and quiet rides to Pune Airport."
    },
    {
        "name": "Pune Airport SUV Taxi",
        "description": "Traveling with family or extra luggage? Book an SUV taxi with Meghana Cab for a spacious and smooth airport ride. Perfect for groups or travelers needing ample storage."
    },
    {
        "name": "Round Trip Cab to Pune Airport",
        "description": "Planning a return trip the same day? Meghana Cab offers round-trip airport cab packages from Pune, ensuring you get picked up and dropped off conveniently and cost-effectively."
    },
    {
        "name": "Prepaid Cab to Pune Airport",
        "description": "Skip last-minute hassles with Meghana Cab’s prepaid taxi service to Pune Airport. Book in advance, pay online, and enjoy a smooth, stress-free airport ride without surge pricing or delays."
    },
    {
        "name": "Pune Airport Luggage Taxi",
        "description": "Carrying heavy or oversized luggage? Meghana Cab offers luggage-friendly airport taxis in Pune with extra boot space and helpful drivers to assist with your belongings."
    },
    {
        "name": "Corporate Airport Taxi Pune",
        "description": "Meghana Cab offers reliable airport taxi services in Pune for corporate clients. Whether it's VIP pickup, client transfer, or employee drops, we offer on-time service with billing and invoicing support."
    }
],

"tableData": [
    ["Pune Airport Pickup and Drop", "Pune Airport Cab Booking"],
    ["Cab to Pune Airport", "Airport Taxi from Pune City"],
    ["Airport Transfer Services Pune", "AC Taxi for Pune Airport"],
    ["Affordable Pune Airport Cab", "Pune Airport to City Taxi"],
    ["24/7 Airport Cab Service Pune", "Book Sedan for Pune Airport Drop"],
    ["Pune Airport SUV Taxi", "Round Trip Cab to Pune Airport"],
    ["Prepaid Cab to Pune Airport", "Pune Airport Luggage Taxi"],
    ["Corporate Airport Taxi Pune", ""],
    ["", ""]
],











"whychoose": [
    {
        "WhyChooseheading": "Reliable Pune Airport Taxi Service",
        "WhyChoosedescription": "Meghana Cab offers dependable and punctual Pune airport taxi services for pick-up and drop-off. Whether you're arriving or departing, we ensure a smooth, stress-free airport commute."
    },
    {
        "WhyChooseheading": "On-Time Pick-Up and Drop Guarantee",
        "WhyChoosedescription": "We understand the importance of timing when it comes to flights. Our Pune airport taxi service guarantees on-time arrivals so you never miss a flight or wait unnecessarily."
    },
    {
        "WhyChooseheading": "Professional and Courteous Drivers",
        "WhyChoosedescription": "Our drivers are trained, experienced, and polite. They assist with luggage and ensure a comfortable ride to or from Pune Airport, prioritizing your convenience."
    },
    {
        "WhyChooseheading": "Available 24/7 for Airport Travel",
        "WhyChoosedescription": "Flights don’t follow a 9-to-5 schedule, and neither do we. Meghana Cab’s Pune airport taxi service is available 24/7, including weekends and holidays."
    },
    {
        "WhyChooseheading": "Clean and Comfortable Cabs",
        "WhyChoosedescription": "Travel in comfort in our well-maintained, air-conditioned, and sanitized taxis. All vehicles come equipped with safety features like seat belts and GPS tracking."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Fare Structure",
        "WhyChoosedescription": "Enjoy fair, upfront pricing with no hidden fees. Meghana Cab provides cost-effective Pune airport taxi services that are easy on your budget."
    },
    {
        "WhyChooseheading": "Pickup from Any Location in Pune",
        "WhyChoosedescription": "No matter where you are in Pune—home, hotel, or office—our airport taxi will reach your doorstep promptly and take you to or from the airport with ease."
    },
    {
        "WhyChooseheading": "Easy Booking via App, Website, or Phone",
        "WhyChoosedescription": "Book your Pune airport taxi in seconds through our mobile app, website, or by calling our 24/7 support team. Quick confirmations and real-time tracking make the process seamless."
    }
]































    }

const faqData = [
    {
        question: "How can I book a Pune Airport taxi with Meghana Cab?",
        answer: "You can easily book a Pune Airport taxi by calling Meghana Cab at +91 9075462128 or using our website for online booking."
    },
    {
        question: "Is your taxi service available for both pickup and drop at Pune Airport?",
        answer: "Yes, Meghana Cab offers both pickup and drop services to and from Pune Airport at any time of the day or night."
    },
    {
        question: "How early should I book my airport taxi in Pune?",
        answer: "It’s best to book at least 1 hour in advance, but we also accept last-minute bookings based on availability."
    },
    {
        question: "Are your drivers punctual for airport pickups?",
        answer: "Yes, our drivers are highly punctual and track flight timings to ensure timely pickups and drops."
    },
    {
        question: "What types of vehicles are available for airport transfers?",
        answer: "We offer hatchbacks, sedans, SUVs, and tempo travellers depending on your preference and luggage needs."
    },
    {
        question: "Can I book a Pune Airport taxi for outstation destinations?",
        answer: "Absolutely! You can book direct airport-to-city or airport-to-outstation rides with Meghana Cab."
    },
    {
        question: "Is the Pune Airport taxi service available 24/7?",
        answer: "Yes, our airport taxi services are available 24/7 to accommodate flights at all hours."
    },
    {
        question: "Are your taxis safe and sanitized?",
        answer: "Yes, all vehicles are sanitized before each trip, and our drivers follow proper hygiene and safety protocols."
    },
    {
        question: "What payment methods are accepted for Pune Airport taxi bookings?",
        answer: "We accept UPI, debit/credit cards, net banking, and cash for your convenience."
    },
    {
        question: "How can I contact Meghana Cab for airport taxi bookings?",
        answer: "To book your Pune Airport taxi, call Meghana Cab anytime at +91 9075462128."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Rajeev Menon',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Booked a Pune Airport taxi with Meghana Cab. The driver was on time, courteous, and the ride was very comfortable.”',
    },
    {
        name: 'Mrs. Swati Kulkarni',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Meghana Cab made my airport transfer so easy. Reliable service, even at 4 AM. Highly recommended!”',
    },
];
























































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];









// ✅ JSON-LD objects (define above your Helmet)
const cabServiceSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "@id": "https://www.meghanacabs.com/pune-airport-taxi#service",
  "serviceType": "Pune Airport Taxi",
  "provider": {
    "@type": "LocalBusiness",
    "name": "Meghana Cabs",
    "url": "https://www.meghanacabs.com/"
  },
  "areaServed": ["Pune","Pimpri-Chinchwad","PNQ Pune International Airport","Viman Nagar","Maharashtra"],
  "description": "24x7 Pune Airport taxi service (PNQ) for pickup and drop. Fixed, transparent fares; meet-and-greet; clean AC Sedan & SUV; verified professional drivers.",
  "offers": {
    "@type": "AggregateOffer",
    "priceCurrency": "INR",
    "lowPrice": "699",
    "highPrice": "2499",
    "offerCount": "10",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/pune-airport-taxi"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",
    "ratingCount": 5486
  }
};

const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "@id": "https://www.meghanacabs.com/#biz",
  "name": "Meghana Cabs",
  "url": "https://www.meghanacabs.com/",
  "image": "https://www.meghanacabs.com/assets/images/pune-airport-taxi.jpg",
  "priceRange": "₹₹",
  "address": {
    "@type": "PostalAddress",
    "addressLocality": "Pune",
    "addressRegion": "MH",
    "addressCountry": "IN"
  },
  "areaServed": ["Pune","Pimpri-Chinchwad","PNQ Pune International Airport","Hinjawadi","Kharadi","Viman Nagar"],
  "openingHoursSpecification": [{
    "@type": "OpeningHoursSpecification",
    "dayOfWeek": ["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"],
    "opens": "00:00",
    "closes": "23:59"
  }],
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": 6372
  }
};

const breadcrumbSchema = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": [
    { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://www.meghanacabs.com/" },
    { "@type": "ListItem", "position": 2, "name": "Pune Airport Taxi", "item": "https://www.meghanacabs.com/pune-airport-taxi" }
  ]
};

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "Do you offer fixed fares for Pune Airport pickup and drop?",
      "acceptedAnswer": { "@type": "Answer", "text": "Yes, all Pune Airport (PNQ) pickups and drops come with upfront, fixed fares—no surge pricing." }
    },
    {
      "@type": "Question",
      "name": "What car types are available for airport rides?",
      "acceptedAnswer": { "@type": "Answer", "text": "Sedan, SUV, and premium AC cars—clean, well-maintained, driven by verified professionals." }
    },
    {
      "@type": "Question",
      "name": "Is the service available 24x7?",
      "acceptedAnswer": { "@type": "Answer", "text": "Yes. Early morning and late-night flights are covered with on-time pickups and flight tracking." }
    },
    {
      "@type": "Question",
      "name": "Do you provide meet-and-greet at arrivals?",
      "acceptedAnswer": { "@type": "Answer", "text": "Yes, your driver can meet you at the arrivals gate with your name board on request." }
    }
  ]
};




    return (
        <div>

<Helmet>
  <title>Pune Airport Taxi (PNQ) | Fixed Fare Pickup & Drop | Meghana Cabs</title>
  <meta
    name="description"
    content="Book Pune Airport taxi (PNQ) for reliable pickup & drop. Fixed fares, 24x7 service, meet-and-greet, clean AC Sedan & SUV, verified drivers. Instant booking."
  />
  <link rel="canonical" href="https://www.meghanacabs.com/pune-airport-taxi" />
  <meta name="robots" content="index,follow,max-snippet:-1,max-image-preview:large,max-video-preview:-1" />

  {/* Optional: keep if you still want it */}
  <meta
    name="keywords"
    content="Pune Airport Taxi, PNQ Airport Pickup, Pune Airport Drop, Airport Cab Pune, Viman Nagar Airport Taxi, Fixed Fare Airport Cab Pune, 24x7 Airport Taxi Pune"
  />

  {/* Open Graph */}
  <meta property="og:type" content="website" />
  <meta property="og:title" content="Pune Airport Taxi | Meghana Cabs" />
  <meta
    property="og:description"
    content="24x7 PNQ airport pickup & drop with fixed fares. Clean AC cars and verified drivers."
  />
  <meta property="og:url" content="https://www.meghanacabs.com/pune-airport-taxi" />
  <meta property="og:image" content="https://www.meghanacabs.com/assets/images/pune-airport-taxi.jpg" />

  {/* Twitter */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content="Pune Airport Taxi | Meghana Cabs" />
  <meta
    name="twitter:description"
    content="Book PNQ airport taxi—fixed fares, meet-and-greet, 24x7 service."
  />
  <meta name="twitter:image" content="https://www.meghanacabs.com/assets/images/pune-airport-taxi.jpg" />

  {/* JSON-LD */}
  <script type="application/ld+json">{JSON.stringify(cabServiceSchema)}</script>
  <script type="application/ld+json">{JSON.stringify(localBusinessSchema)}</script>
  <script type="application/ld+json">{JSON.stringify(breadcrumbSchema)}</script>
  <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
</Helmet>



            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/20.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                             <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Puneairporttaxi;